import React from 'react'

export type SweetspotMarkVariant =
  | 'static'
  /** The mark stroked white, for the dark chrome professional paints. */
  | 'static-white'
  | 'pulse-clearstart'
  | 'pulse-markstart'
  | 'nopulse-clearstart'
  | 'nopulse-markstart'

const VARIANT_SRC: Record<SweetspotMarkVariant, string> = {
  static: '/sweetspot-mark.svg',
  'static-white': '/sweetspot-mark-white.svg',
  'pulse-clearstart': '/sweetspot-mark-pulse-clearstart.svg',
  'pulse-markstart': '/sweetspot-mark-pulse-markstart.svg',
  'nopulse-clearstart': '/sweetspot-mark-nopulse-clearstart.svg',
  'nopulse-markstart': '/sweetspot-mark-nopulse-markstart.svg',
}

export const sweetspotMarkSrc = (variant: SweetspotMarkVariant): string =>
  VARIANT_SRC[variant]

interface SweetspotMarkProps {
  variant: SweetspotMarkVariant
  size?: number
  className?: string
  style?: React.CSSProperties
}

export const SweetspotMark: React.FC<SweetspotMarkProps> = ({
  variant,
  size = 16,
  className,
  style,
}) => {
  return (
    <img
      src={VARIANT_SRC[variant]}
      alt=""
      aria-hidden
      width={size}
      height={size}
      draggable={false}
      className={className}
      style={style}
    />
  )
}

export default SweetspotMark
